<template>
	<div class="order-list">
		<normal-table
			ref="normalTable"
			method="post"
			:tableAction="tableAction"
			:url="url"
			:extra-query="{}"
			hasResetBtn
			:searchForm.sync="form"
			:page-size="200"
			:has-search-form="true"
			@select="select"
			@select-all="selectAll"
			@loaded="loaded"
		>
			<template slot="formItem">
				<el-form-item label="选择平台">
					<el-select v-model="form.platform" placeholder="平台" style="width:170px">
						<el-option label="百家号" value="baijiahao"></el-option>
						<el-option label="官网" value="officialWeb"></el-option>
						<el-option label="小红书" value="redBook"></el-option>
						<el-option label="抖音" value="tiktok"></el-option>
						<el-option label="哔哩哔哩" value="bilibili"></el-option>
						<el-option label="网易号" value="yangyi"></el-option>
						<el-option label="头条号" value="toutiaohao"></el-option>
						<el-option label="大鱼号" value="dayuhao"></el-option>
					</el-select>
				</el-form-item>
			</template>
			<div slot="otherContent" class="otherContent">
				<div class="tableAction">
					<el-button @click="addBind" type="primary">添加绑定</el-button>
					<el-button @click="checkBind" type="primary">批量检查登录</el-button>
				</div>
			</div>
		</normal-table>
	</div>
</template>

<script>
import NormalTable from "@/components/NormalTable/index.vue";
import {isPcClient} from "@/utils/utils";

export default {
	data() {
		return {
			total: 0,
			otherMap: {totalAccount:0},
			dateRange: [],
			form: {
				platform: ''
			},
			url: "/client/driver/getDriverList",
			tableAction: {
				label: "操作",
				prop: "handle",
				align: "center",
				formatter: (data) => {
					return (
						<div class="action" vLoading={this.loadingMap['action'+data.index]}>
							<el-button type="primary" class="item" onClick={() => this.editDriver(data)}>编辑</el-button>
              <el-button type="primary" className="item" onClick={() => this.openDriver(data)}>打开</el-button>
							<el-button type="primary" vShow={data.status === '正常登录'} className="item" onClick={() => this.checkLogin(data)}>检查登录</el-button>
							<el-button type="primary" vShow={data.status !== '正常登录'} className="item" onClick={() => this.execLogin(data)}>请重新登录</el-button>
              <el-popconfirm title="确定删除这个平台嘛？" onConfirm={() => this.delete(data)}>
                <el-button slot="reference" type="primary">删除</el-button>
              </el-popconfirm>
						</div>
					);
				},
			},
			selectList: [],
			loadingMap: {"action1": false,"action2": false,"action3": false,"action4": false,"action5": false,"action6": false,"action7": false,"action8": false,"action9": false,"action10": false,"action11": false,"action12": false,"action13": false,"action14": false,"action15": false,"action16": false,"action17": false,"action18": false,"action19": false,"action20": false,"action21": false,"action22": false,"action23": false,"action24": false,"action25": false,"action26": false,"action27": false,"action28": false,"action29": false,"action30": false,"action31": false,"action32": false,"action33": false,"action34": false,"action35": false,"action36": false,"action37": false,"action38": false,"action39": false,"action40": false,"action41": false,"action42": false,"action43": false,"action44": false,"action45": false,"action46": false,"action47": false,"action48": false,"action49": false,"action50": false,"action51": false,"action52": false,"action53": false,"action54": false,"action55": false,"action56": false,"action57": false,"action58": false,"action59": false,"action60": false,"action61": false,"action62": false,"action63": false,"action64": false,"action65": false,"action66": false,"action67": false,"action68": false,"action69": false,"action70": false,"action71": false,"action72": false,"action73": false,"action74": false,"action75": false,"action76": false,"action77": false,"action78": false,"action79": false,"action80": false,"action81": false,"action82": false,"action83": false,"action84": false,"action85": false,"action86": false,"action87": false,"action88": false,"action89": false,"action90": false,"action91": false,"action92": false,"action93": false,"action94": false,"action95": false,"action96": false,"action97": false,"action98": false,"action99": false,"action100": false,"action101": false,"action102": false,"action103": false,"action104": false,"action105": false,"action106": false,"action107": false,"action108": false,"action109": false,"action110": false,"action111": false,"action112": false,"action113": false,"action114": false,"action115": false,"action116": false,"action117": false,"action118": false,"action119": false,"action120": false,"action121": false,"action122": false,"action123": false,"action124": false,"action125": false,"action126": false,"action127": false,"action128": false,"action129": false,"action130": false,"action131": false,"action132": false,"action133": false,"action134": false,"action135": false,"action136": false,"action137": false,"action138": false,"action139": false,"action140": false,"action141": false,"action142": false,"action143": false,"action144": false,"action145": false,"action146": false,"action147": false,"action148": false,"action149": false,"action150": false,"action151": false,"action152": false,"action153": false,"action154": false,"action155": false,"action156": false,"action157": false,"action158": false,"action159": false,"action160": false,"action161": false,"action162": false,"action163": false,"action164": false,"action165": false,"action166": false,"action167": false,"action168": false,"action169": false,"action170": false,"action171": false,"action172": false,"action173": false,"action174": false,"action175": false,"action176": false,"action177": false,"action178": false,"action179": false,"action180": false,"action181": false,"action182": false,"action183": false,"action184": false,"action185": false,"action186": false,"action187": false,"action188": false,"action189": false,"action190": false,"action191": false,"action192": false,"action193": false,"action194": false,"action195": false,"action196": false,"action197": false,"action198": false,"action199": false,"action200": false},
		};
	},
	
	components: {
		NormalTable,
	},
	
	computed: {},
	
	mounted() {
	},
	
	watch: {
	},
	
	methods: {
		// 获取接口数据
		loaded(data) {
		},
		select(selection) {
			this.selectList = selection;
		},
		selectAll(selection) {
			this.selectList = selection;
		},
		addBind() {
			this.$router.push({ path: "/driver/driverDetail" }).then(() => {
        try {
          this.$route.matched.find(route => route.path === '/driver/driverDetail').instances.default.resetForm();
        } catch (e) {
          console.log(e)
        }
      })
		},
		checkBind() {
			if (this.selectList.length === 0) {
				this.$message.warning('请先选择账户')
				return;
			}
			this.selectList.forEach(item => {
				this.checkLogin(item)
			})
		},
		resetForm() {
			this.dateRange = []
			this.form = {}
		},
		setOtherMap(map) {
			this.otherMap = map
		},
		
		editDriver(data) {
				this.$router.push({ path: "/driver/driverDetail", query: { id: data._id } }).then(() => {
					try {
						this.$route.matched.find(route => route.path === '/driver/driverDetail').instances.default.init();
					} catch (e) {
						console.log(e)
					}
				})
		},
    openDriver(data) {
      if (!isPcClient()) {
        this.$message.error('请在PC客户端使用此功能')
        return
      }
      pywebview.api.dispatchOpen(data).then(res => {
        if (res !== 'success') {
          this.cookieIsInValid(data).catch(() => {})
          this.$message.error('此驱动登录已失效,将重新执行登录过程, 请辅助完成登录动作')
          this.execLogin(data)
        }
      }).finally(() => {
        this.loadingMap['action'+data.index] = false
      })
    },
    delete(data) {
      return this.$http.post('/client/driver/delete', {id:data._id}).then(res => {
        this.$message.success('删除成功')
        this.$refs.normalTable.getList()
      })
    },
		
		cookieIsInValid(data) {
			return this.$http.post('/client/driver/cookieIsInValid', {id:data._id}).then(res => {
        this.$refs.normalTable.getList()
			})
		},
		
		checkLogin(data) {
			if (!data.cookie) {
				this.cookieIsInValid(data)
				return
			}
			if (!isPcClient()) {
				this.$message.error('请在PC客户端使用此功能')
				return
			}
			this.loadingMap['action'+data.index] = true
			pywebview.api.dispatchLoginCheck(data).then(isLogin => {
				if (!isLogin) {
					this.$message.error('此驱动登录已失效,将重新执行登录过程, 请辅助完成登录动作')
					this.cookieIsInValid(data).catch(() => {})
					this.execLogin(data)
				} else {
					this.$message.success('此账户正常运行中')
				}
			}).finally(() => {
				this.loadingMap['action'+data.index] = false
			})
		},
		
		async execLogin(data) {
			
			if (!isPcClient()) {
				this.$message.error('请在PC客户端使用此功能')
				return
			}
			
			this.loadingMap['action'+data.index] = true
			pywebview.api.dispatchLogin(data).then(res => {
				if (!res) {
					this.$message.error('这条记录无法完成登录, 请检查信息填写是否正确')
					return
				}
				this.$http.post('/client/driver/newCookieValid', {id:data._id, cookie:res}).then(res => {
					if (res.code === 0) {
						this.$message.success('本驱动已更行')
						this.$refs.normalTable.getList()
						this.$forceUpdate()
					}
				})
			}).finally(() => {
				this.loadingMap['action'+data.index] = false
			})
		},
		
	},
};
</script>
<style lang="scss" scoped>
.el-form-item {
	flex-wrap: nowrap;
}
.order-list {
	.total {
		font-size: 14px;
		color: #333;
		text-align: right;
		padding-right: 30px;
	}
	.input-amount{
		display: inline-block;
		width: 100px;
	}
	.phone {
		width: 115px;
	}
	.day {
		width: 60px;
	}
}
.otherContent {
	display: flex;
	justify-content: space-between;
	margin-top: 15px;
	flex-wrap: wrap;
	.tableAction {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-right: 5px;
		.el-button {
			margin-bottom: 5px;
		}
	}
	.allAccount {
		display: grid;
		place-items: end;
	}
}
::v-deep .el-message-box {
	max-width: 100% !important;
}
.el-message-box__message {
	max-width: 100% !important;
}
.action {
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	.item {
		margin-left: 5px !important;
		margin-right: 5px !important;
	}
}
</style>
<style>
.el-message-box {
	max-width: 100% !important;
}
</style>